
import global from 'Core/global';
import { closest } from 'Core/polyfill';
import svg4everybody from 'Libs/svg4everybody/svg4everybody';
import q from 'Utils/q';
import size from 'Utils/size';

// const svg4everybody = require('Libs/svg4everybody/svg4everybody');

export default () => {

	// Polyfills

	closest();

	svg4everybody();

	// Core functions

	size();

	// Add/remove classnames on page load

	const html = q('html');

	html.removeClass('global__no-js').addClass('global__has-js');

	if (global.state.isInIframe) {

		html.addClass('global__is-in-iframe');

	}

};